import {Component, OnInit} from '@angular/core';
import {HealthInsuranceService} from '../../../services/health-insurance.service';
import { Response, StaticMethods, Question} from '../../../model/GeneralModels';
import {FormBuilder, FormGroup} from '@angular/forms';
import {AppSettingsService} from '../../../services/app-settings.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class QuestionsComponent implements OnInit {
  title = 'پرسشنامه';
  formGroup: FormGroup = this.fb.group({});
  subRequestID: number;
  requestID: number;
  myRequestsUrl: string;
  productName: string;

  constructor(
    private service: HealthInsuranceService,
    private fb: FormBuilder,
    private appSettings: AppSettingsService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit() {
    // this.clientKey = Authorization.getClientKey(this.activatedRoute, this.router);
    // this.mobile = Authorization.getMobile(this.activatedRoute, this.router);
    // if (this.clientKey && this.mobile) {
    this.productName = StaticMethods.getProductName(this.router, true);
    this.myRequestsUrl = `/${this.productName}/requests`;
    if (StaticMethods.checkState(
      this.router,
      ['requestID', 'subRequestID'],
      [this.myRequestsUrl, '/health/family/details'])
    ) {
      this.subRequestID = history.state.subRequestID;
      this.requestID = history.state.requestID;
    }
  }

  submit() {
    // console.log(this.formGroup.value);
    if (this.formGroup.valid) {
      this.service.submitForm(this.requestID, this.subRequestID, this.formGroup.value)
        .subscribe((response: Response) => {
          if (response.success) {
            this.router.navigate(['/health/family/details'], {
              state: {
                requestID: this.requestID
              }
            });
          }
        });
    } else {
      this.formGroup.markAllAsTouched();
    }
  }

}
